<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :disabled="disabled"
      @reload="reload"
      @change="change"
      ref="MAIN"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  props:{
    disabled: {type: Boolean, default: false}
  },
  data() {
    return {
      usePage: true,
      reviewVisible: false,
      table: [],
      amzFlipOrderSkuCodes: [],
    }
  },
  methods: {
    query(amzFlipOrderSkuCodes) {
      this.amzFlipOrderSkuCodes = amzFlipOrderSkuCodes
      this.$refs.header.query({ isReset: false })
    },
    getTableData() {
      return this.$refs.MAIN.getTableData()
    },
    change({ tableData}) {
      this.$emit('change', tableData)
    },
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFlipOrderSkuListApi({
          ...form,
          ...this.page,
          amzFlipOrderSkuCodes: this.amzFlipOrderSkuCodes,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
